import 'twin.macro';
import 'styled-components/macro';
import { useEffect, useState } from 'react';

import { Button } from 'play/atoms/button/Button';
import { Modal, ModalBody, ModalFooter } from 'play/molecules/modal/Modal';
import { shortEnglishHumanizer } from 'support/dates';

import { ReactComponent as Image } from './images/extend.svg';

export interface ExtendTTLModalProps {
  extraMinutes: number;

  onExtend(): void;
  onExpire?(): void;
}

export const ExtendTTLModal = ({ extraMinutes, onExtend, onExpire }: ExtendTTLModalProps) => {
  const [timeLeft, setTimeLeft] = useState(30);

  const isExpired = timeLeft <= 0;

  useEffect(() => {
    if (isExpired) {
      onExpire?.();
      return;
    }

    const timer = setInterval(() => setTimeLeft(t => t - 1), 1000);
    return () => clearInterval(timer);
  });

  return (
    <Modal title="Time's up. Do you want to keep going?" width="large" open hideCloseIcon>
      <ModalBody tw="flex justify-center py-2">
        <Image width={300} />
      </ModalBody>

      <ModalFooter>
        <div tw="flex justify-between items-center w-full">
          <div tw="text-gray-15">
            <span tw="text-gray-70">Shutting down in: </span>
            {shortEnglishHumanizer(timeLeft * 1000, { round: true, delimiter: ', ' })}
          </div>
          <div>
            <Button variant="outline" tw="mr-2" onClick={onExpire}>
              Exit
            </Button>

            <Button onClick={onExtend}>Add {extraMinutes} minutes</Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};
